import BaseService from '@/services/base_service';

export default class GraphicService extends BaseService {
    async get(params) {
        try {


            return await axios.get('/grafico', { params });
        } catch (e) {
            throw e;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/graphic.js